import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createHomeSection } from "../../api/apiHomeSections";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";

export const useCreateHomeSection = () => {
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    const { mutate: createSectionMutate, isPending } = useMutation({
        mutationFn: createHomeSection,
        onSuccess: (res) => {
            toast.success(res.message);
            queryClient.invalidateQueries(["home-sections"]);
        },
        onError: (error) => {
            console.error("Error creating home section:", error);
            toast.error(error.response?.data?.message || t("Error creating home section"));
        },
    });

    return { createSectionMutate, isPending };
};
